var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13V7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9c-3 0-5-2-5-5 3 0 5 2 5 5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11c3 0 5-2 5-5-3 0-5 2-5 5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14h8l-1 7H9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.a904b477eae0bdf5d699942c7c4d0f73.svg";
export { ForwardRef as ReactComponent };